import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';

const AdminAppointments = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get('/admin/appointments').then(({ data }) => setItems(data)); }, []);

  return (
    <div>
      <h1 className="font-serif text-4xl text-sans_ink tracking-tight">Appointments</h1>
      <p className="text-sans_mute mt-2">All consultation bookings.</p>
      <div className="mt-8 bg-white border border-sans_line overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="border-b border-sans_line">
            {['Patient', 'Doctor', 'When', 'Fee', 'Status', 'Reason'].map((h) => <th key={h} className="text-left px-4 py-3 font-medium text-[11px] tracking-[0.18em] uppercase text-sans_mute">{h}</th>)}
          </tr></thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={6} className="px-4 py-8 text-center text-sans_mute">No appointments yet.</td></tr>}
            {items.map((a) => (
              <tr key={a.appointment_id} className="border-b border-sans_line hover:bg-sans_bone/50">
                <td className="px-4 py-3 text-sans_ink">{a.user_name}<div className="text-xs text-sans_mute">{a.user_email}</div></td>
                <td className="px-4 py-3 text-sans_ink">{a.doctor_name}</td>
                <td className="px-4 py-3 text-sans_mute">{new Date(a.slot_datetime).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' })}</td>
                <td className="px-4 py-3 text-sans_ink">₹{a.fee}</td>
                <td className="px-4 py-3 text-sans_mute">{a.status}</td>
                <td className="px-4 py-3 text-sans_mute max-w-xs truncate">{a.reason || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminAppointments;
